import { getCopyWorkflowBindleAuthorizationRequest } from 'src/authentication/bindle-utils';
import { useBindleAuthorization } from 'src/hooks/useBindleAuthorization';

/**
 * Hook to check if the current user has permission to copy workflows
 * Uses a dedicated Bindle set for copy permissions
 */
export function useCopyWorkflowPermissions(userName: string | undefined) {
	const { isAuthorized, isCheckingPermission, permissionError } =
		useBindleAuthorization(
			userName,
			getCopyWorkflowBindleAuthorizationRequest()
		);

	return {
		canCopyWorkflow: isAuthorized,
		isCheckingPermission,
		permissionError,
	};
}
